module.exports = __webpack_public_path__ + "img/point_title1.af01704f.svg";